import { createApp } from "vue";
import Widget from "./Widget.vue";
// import Component from "./Component.vue";

import "tippy.js/dist/tippy.css";

const app = createApp(Widget);

// app.component("component", Component);

app.mount("#widget");
